import { Editor } from "react-draft-wysiwyg";

import PanelContent from "Components/Panels/PanelContent";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useFormikContext } from "formik";
import { convertToRaw, EditorState, ContentState } from "draft-js";
import { useEffect, useState } from "react";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";

const EDITOR_TOOLBAR = {
  options: [
    "inline",
    "blockType",
    "fontSize",
    "fontFamily",
    "list",
    "textAlign",
    "link",
    "embedded",
    "emoji",
    "image",
    "remove",
    "history",
  ],
  inline: { inDropdown: true },
  list: { inDropdown: true },
  textAlign: { inDropdown: true },
  link: { inDropdown: true },
  history: { inDropdown: true },
};

const INITIAL_EDITORS = {
  editorReference: "reference",
  editorUnmetProducts: "unmet_products",
  editorFacilities: "facilities",
  editorParkingDesk: "parking_desk",
};

const createEditors = (values) => {
  const blocksFromReference = htmlToDraft(values.reference);
  const blocksFromUnmetProducts = htmlToDraft(values.unmet_products);
  const blocksFromFacilities = htmlToDraft(values.facilities);
  const blocksFromParkingDesk = htmlToDraft(values.parking_desk);

  return {
    editorReference: EditorState.createWithContent(
      ContentState.createFromBlockArray(
        blocksFromReference.contentBlocks,
        blocksFromReference.entityMap
      )
    ),
    editorUnmetProducts: EditorState.createWithContent(
      ContentState.createFromBlockArray(
        blocksFromUnmetProducts.contentBlocks,
        blocksFromUnmetProducts.entityMap
      )
    ),

    editorFacilities: EditorState.createWithContent(
      ContentState.createFromBlockArray(
        blocksFromFacilities.contentBlocks,
        blocksFromFacilities.entityMap
      )
    ),
    editorParkingDesk: EditorState.createWithContent(
      ContentState.createFromBlockArray(
        blocksFromParkingDesk.contentBlocks,
        blocksFromParkingDesk.entityMap
      )
    ),
  };
};

const initialEditors = {
  editorReference: EditorState.createEmpty(),
  editorUnmetProducts: EditorState.createEmpty(),
  editorFacilities: EditorState.createEmpty(),
  editorParkingDesk: EditorState.createEmpty(),
};

export function AdditionalInfo() {
  const { setFieldValue, initialValues } = useFormikContext();
  const [editors, setEditors] = useState(initialEditors);

  const {
    editorReference,
    editorUnmetProducts,
    editorFacilities,
    editorParkingDesk,
  } = editors;

  function handleEditorsChange(name, value) {
    const val = draftToHtml(convertToRaw(editors[name].getCurrentContent()));
    setEditors((prev) => ({
      ...prev,
      [name]: value,
    }));
    setFieldValue(INITIAL_EDITORS[name], val);
  }

  useEffect(() => {
    if (
      initialValues.reference ||
      initialValues.unmet_products ||
      initialValues.facilities ||
      initialValues.parking_desk
    )
      setEditors(createEditors(initialValues));
  }, [initialValues]);

  return (
    <div className="row">
      <div className="lg-6">
        <PanelContent title="Pontos de Referência">
          <div
            className="md-12 lg-13"
            style={{ marginBottom: "5rem", marginTop: "1.5rem" }}
          >
            <label className="text-gray text-semibold">Referência</label>
            <Editor
              editorState={editorReference}
              wrapperClassName="demo-wrapper"
              editorClassName="demo-editor"
              onEditorStateChange={(value) =>
                handleEditorsChange("editorReference", value)
              }
              toolbar={EDITOR_TOOLBAR}
            />
          </div>
        </PanelContent>
      </div>

      <div className="lg-6">
        <PanelContent title="o que esta unidade não oferece">
          <div
            className="md-12 lg-13"
            style={{ marginBottom: "5rem", marginTop: "1.5rem" }}
          >
            <label className="text-gray text-semibold">
              o que esta unidade não oferece
            </label>
            <Editor
              editorState={editorUnmetProducts}
              wrapperClassName="demo-wrapper"
              editorClassName="demo-editor"
              onEditorStateChange={(value) =>
                handleEditorsChange("editorUnmetProducts", value)
              }
              toolbar={EDITOR_TOOLBAR}
            />
          </div>
        </PanelContent>
      </div>

      <div className="lg-6">
        <PanelContent title="Acessibilidade">
          <div
            className="md-12 lg-13"
            style={{ marginBottom: "5rem", marginTop: "1.5rem" }}
          >
            <label className="text-gray text-semibold">Acessibilidade</label>
            <Editor
              editorState={editorFacilities}
              wrapperClassName="demo-wrapper"
              editorClassName="demo-editor"
              onEditorStateChange={(value) =>
                handleEditorsChange("editorFacilities", value)
              }
              toolbar={EDITOR_TOOLBAR}
            />
          </div>
        </PanelContent>
      </div>

      <div className="lg-6">
        <PanelContent title="Descrição do Estacionamento">
          <div
            className="md-12 lg-13"
            style={{ marginBottom: "5rem", marginTop: "1.5rem" }}
          >
            <label className="text-gray text-semibold">Descrição</label>
            <Editor
              editorState={editorParkingDesk}
              wrapperClassName="demo-wrapper"
              editorClassName="demo-editor"
              onEditorStateChange={(value) =>
                handleEditorsChange("editorParkingDesk", value)
              }
              toolbar={EDITOR_TOOLBAR}
            />
          </div>
        </PanelContent>
      </div>
    </div>
  );
}
